exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region-name[data-v-1cda4fe6] {\n  width: 70%;\n}\n.region-action[data-v-1cda4fe6] {\n  width: 30%;\n}\n.handle[data-v-1cda4fe6] {\n  cursor: grab;\n  padding: 10px;\n  text-align: center;\n}\n.handle[data-v-1cda4fe6]:active {\n  cursor: grabbing;\n}\n", ""]);

// exports
